import styled from "styled-components";
import BaseSearcherButton from "../../../searcher/searcher-button/index.js";
import { SearcherWrapper } from "../../../searcher/searcher-button/views/desktop/styled.js";
export const SearcherButton = styled(BaseSearcherButton).withConfig({
    displayName: "styled__SearcherButton",
    componentId: "sc-fb11f64c-0"
})`
	min-width: 20%;
	max-width: 20%;

	${SearcherWrapper} {
		flex-grow: 1;
	}

	button {
		max-width: auto;
		min-width: 100%;

		&[disabled] {
			cursor: default;
			opacity: 0.7;
		}
	}
`;

//# sourceMappingURL=styled.js.map